import { render, staticRenderFns } from "./UserDocumentsModal.vue?vue&type=template&id=d14a00ec"
import script from "./UserDocumentsModal.vue?vue&type=script&lang=js"
export * from "./UserDocumentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports